import React from 'react'
import { connect } from 'react-redux'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { Modal } from '..'
import * as Styled from '../styled'
import { BaseGatedBibliographyModalProps } from './types'
import {
  GATED_BIBLIOGRAPHY_MODAL,
  GATED_BIBLIOGRAPHY_MODAL_HEADER,
  GATED_BIBLIOGRAPHY_MODAL_MESSAGE,
  GATED_BIBLIOGRAPHY_MODAL_UPGRADE_BUTTON,
  GATED_BIBLIOGRAPHY_MODAL_CONTINUE_BUTTON,
} from './testIds'

export const BaseGatedBibliographyModal: React.FC<BaseGatedBibliographyModalProps> = ({
  modalName,
  header,
  message,
  isDismissible,
  onContinue,
  onUpgrade,
  close,
}) => {
  const continueButtonText = 'Continue'
  const upgradeButtonText = 'Upgrade'

  const handleUpgrade = () => {
    close(modalName)
    onUpgrade(upgradeButtonText)
  }

  const handleContinue = () => {
    close(modalName)
    onContinue(continueButtonText)
  }

  return (
    <Modal showModal outsideClick={isDismissible} closeButton={isDismissible}>
      <Styled.Container data-test={GATED_BIBLIOGRAPHY_MODAL}>
        <Styled.Heading data-test={GATED_BIBLIOGRAPHY_MODAL_HEADER}>
          {header}
        </Styled.Heading>
        <Styled.Message data-test={GATED_BIBLIOGRAPHY_MODAL_MESSAGE}>
          {message}
        </Styled.Message>
        <Styled.ButtonContainer>
          {onContinue && (
            <Styled.CancelButton
              onClick={handleContinue}
              data-test={GATED_BIBLIOGRAPHY_MODAL_CONTINUE_BUTTON}
            >
              {continueButtonText}
            </Styled.CancelButton>
          )}
          <Styled.ConfirmButton
            onClick={handleUpgrade}
            data-test={GATED_BIBLIOGRAPHY_MODAL_UPGRADE_BUTTON}
          >
            {upgradeButtonText}
          </Styled.ConfirmButton>
        </Styled.ButtonContainer>
        <Styled.ButtonContainerMobile>
          {onContinue && (
            <Styled.CancelButton
              onClick={handleContinue}
              data-test={GATED_BIBLIOGRAPHY_MODAL_CONTINUE_BUTTON}
            >
              {continueButtonText}
            </Styled.CancelButton>
          )}
          <Styled.ConfirmButton
            onClick={handleUpgrade}
            data-test={GATED_BIBLIOGRAPHY_MODAL_UPGRADE_BUTTON}
          >
            {upgradeButtonText}
          </Styled.ConfirmButton>
        </Styled.ButtonContainerMobile>
      </Styled.Container>
    </Modal>
  )
}

const mapDispatchToProps = {
  close: (name: string) => closeModal(name),
}

export default connect(null, mapDispatchToProps)(BaseGatedBibliographyModal)
